import { AnimatePresence } from 'framer-motion';
import React, { useState } from 'react';
import { FaAngleDown } from 'react-icons/fa';
import { NavItem } from '../NavBar';
import classes from './DesktopNavItems.module.scss';
import DesktopSubItems from './desktopSubItems/DesktopSubItems';
import { useNavigate } from 'react-router-dom';
import { isNavItemVisible, useNavVisibility } from '../navItemVisibility';

type Props = {
  items: NavItem[];
  ruleAccess: { [id: number]: boolean };
  editMode: boolean;
};

const DesktopNavItems = ({ items, ruleAccess, editMode }: Props) => {
  const navigate = useNavigate();

  const handleNavigate = (
    e: React.MouseEvent<HTMLElement, MouseEvent>,
    url: string,
    urlType: string
  ) => {
    if (urlType === 'external') {
      window.open(url, '_blank');
    } else {
      e.stopPropagation();
      navigate(url);
    }
  };

  const [hoveredItem, setHoveredItem] = useState<NavItem>();
  const visibility = useNavVisibility(ruleAccess, editMode);
  const hasPermission = (item: NavItem) => isNavItemVisible(item, visibility);

  return (
    <div className={classes.container}>
      {items.map((item, index) => {
        return (
          hasPermission(item) && (
            <div
              key={index}
              onMouseEnter={() => {
                if (hoveredItem !== item) setHoveredItem(item);
              }}
              onMouseLeave={() => {
                if (hoveredItem === item) setHoveredItem(undefined);
              }}
              className={classes.container__item}
              onClick={(e) => handleNavigate(e, item.url, item.url_type)}
            >
              <AnimatePresence>
                {hoveredItem === item &&
                  item.dropDownItems &&
                  item.dropDownItems.length > 0 && (
                    <DesktopSubItems
                      item={item}
                      handleNavigate={handleNavigate}
                      visibility={visibility}
                    />
                  )}
              </AnimatePresence>
              <div className={classes.item__label}>
                <span>{item.text}</span>
                {item.dropDownItems.length > 0 && <FaAngleDown />}
              </div>
            </div>
          )
        );
      })}
    </div>
  );
};

export default DesktopNavItems;
